import { Quote } from "lucide-react";
import "./testimonials-page-list.css";
import { clientTestimonials } from "../data/testimonials.data";

export default function TestimonialsList() {
  return (
    <section className="oglitz-testimonials-page-list">
      <div className="oglitz-testimonials-page-list__container">
        <div className="oglitz-testimonials-page-list__grid">
          {clientTestimonials.map((item, index) => (
            <div key={index} className="oglitz-testimonials-page-card">
              <Quote />
              <p>{item.quote}</p>
              <div className="oglitz-testimonials-page-card__author">
                <strong>{item.name}</strong>
                <span>{item.role}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
